export default {
    methods: {
        loadScript(url) {
            let that = this;

            let urls = !Array.isArray(url) ? [url] : url;

            return Promise.all(
                urls.map(url =>
                    new Promise(function(resolve, reject) {
                        var script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.async = true;
                        script.id = that.hash(url);
                        script.src = url;
                        script.onload = resolve;
                        script.onerror = reject;
                        if (!document.getElementById(script.id)) {
                            document.head.appendChild(script);
                        }
                    }).then(() => {
                        return true;
                    }),
                ),
            );
        },
        load(callInterval, delay, url, cb) {
            let that = this;
            let r,
                timeSpend,
                i = setInterval(function() {
                    timeSpend += callInterval;
                    r = typeof require === 'function';
                    if (timeSpend >= delay || r) clearInterval(i);
                    if (r) {
                        that.loadScript(url)
                            .then(cb)
                            .catch(function(err) {
                                console.error('Something went wrong!', err);
                            });
                    }
                }, callInterval);
        },
        hash(str, seed = 0) {
            let h1 = 0xdeadbeef ^ seed,
                h2 = 0x41c6ce57 ^ seed;
            for (let i = 0, ch; i < str.length; i++) {
                ch = str.charCodeAt(i);
                h1 = Math.imul(h1 ^ ch, 2654435761);
                h2 = Math.imul(h2 ^ ch, 1597334677);
            }
            h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
            h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
            return 4294967296 * (2097151 & h2) + (h1 >>> 0);
        },
    },
};
